import React, { createContext, useContext, useEffect } from "react";

import { useSearchParams } from "react-router-dom";

import {
  applyThemeToDocument,
  REBRAND_SEARCH_PARAM,
  ThemeName,
} from "src/styles/themes/applyTheme";

export const ThemeContext = createContext<ThemeName>("default");

/**
 * Resolves the active theme from the URL and mirrors it onto
 * <html data-theme> so the CSS variable overrides in rebrand.css apply.
 * Must render inside the router.
 */
export const ThemeProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [searchParams] = useSearchParams();
  const theme: ThemeName = searchParams.has(REBRAND_SEARCH_PARAM)
    ? "rebrand"
    : "default";

  useEffect(() => {
    applyThemeToDocument(theme);
    return () => applyThemeToDocument("default");
  }, [theme]);

  return <ThemeContext value={theme}>{children}</ThemeContext>;
};

/**
 * For JS-land styling that cannot read CSS variables (charts, Emotion).
 * Prefer Tailwind classes with the `rebrand:` variant; they switch themes
 * automatically.
 */
export const useTheme = (): ThemeName => useContext(ThemeContext);
